module.exports = __webpack_public_path__ + "static/media/insulin-pump.8ff2e2a5.png";